<template>
	<div class="centerWidth">
		<div class="gaokao">
			<div class="gaokao-nav">
				<span @click="goMyCenter">个人中心 ></span>
				<span>填：智能选专业</span>
			</div>
			<section class="gaokao-content">
				<article class="yuan_top">
					<div class="yuan_head">
						<div class="yuan_tab zhong flex">
							<label>智能选专业：</label>
							<el-select v-model="cityName" placeholder="请选择" class="yuanXz">
								<el-option v-for="item in cityList" :key="item.Code" :label="item.Name" :value="item.Code"></el-option>
							</el-select>
							<el-select v-model="value" placeholder="请选择" class="yuanXz">
								<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
							</el-select>
						</div>
						<div class="major-share-con">
							<div class="share-li">
								<p>参考分数:</p>
								<input placeholder="请输入" type="number" v-model="Score" />
							</div>
							<div class="major-btn01"><button class="gaokao-btn" @click="selectlist()">搜索</button></div>
						</div>
					</div>
					<div class="yuan_head_hg float">
						<img src="../../../image/ts.png" />
						<hgroup>
							<h6>择校分析</h6>
							<p>根据对往年录取信息进行分析，系统判断您有以下专业可进行筛选</p>
							<p>可冲击专业:您可以尝试冲击进入该专业，但是可能存在掉档的风险</p>
							<p>较稳定专业:专业的录取概率较大，但报考热门专业可能存在风险</p>
							<p>保底专业:可以保底录取的专业，降低志愿填报掉档风险</p>
						</hgroup>
					</div>
				</article>

				<article class="tabTop flex">
					<p :class="isTab == 1 ? 'on' : ''" @click="tabClick(1)">可冲击专业({{ TypeId1 }}所)</p>
					<p :class="isTab == 2 ? 'on' : ''" @click="tabClick(2)">较稳定专业({{ TypeId2 }}所)</p>
					<p :class="isTab == 3 ? 'on' : ''" @click="tabClick(3)">较保底专业({{ TypeId3 }}所)</p>
				</article>

				<article class="yuanList" v-if="isShow">
					<ul>
						<li v-for="(item, index) in list" :key="index">
							<div class="list_head zhong float">
								<div class="list_head_flex">
									<div class="list-four">
										<h6>{{ item.CollegesName }}</h6>
									</div>
									<div class="list-four">
										<hgroup class="flex zhong">
											<p>
												院校代码:
												<span>{{ item.CollegesCode }}</span>
											</p>
											<i v-if="isTab == 1">可冲击</i>
											<i v-else-if="isTab == 2" style="background-color: #ffe3be;color: #f59a23;">较稳定</i>
											<i v-else-if="isTab == 3" style="background-color: #ccedc6;color: #63be52;">保底</i>
										</hgroup>
									</div>
								</div>
								<div class="list-four">
									<p style="text-align: right;">
										招生计划:
										<span>{{ item.EnrollmentPlan }}</span>
									</p>
								</div>
							</div>
							<div class="beiTxt" style="margin-top: 30px;">
								<p>
									<span>专业名称:</span>
									{{ item.MajorName }}
								</p>
							</div>
							<div class="listTxt">
								<p>
									招生地区：
									<span>{{ item.EnrollmentArea }}</span>
								</p>
								<p>
									考生类别：
									<span>{{ item.CandidatesType }}</span>
								</p>
								<p>
									平均分：
									<span>{{ item.Average }}</span>
								</p>
								<p>
									最低分：
									<span>{{ item.LowestScore }}</span>
								</p>
								<p>
									最低位次：
									<span>{{ item.LowestOrder }}</span>
								</p>
							</div>
							<p class="beiTxt">
								<span>备注：{{ item.Remarks }}</span>
							</p>
						</li>
					</ul>
				</article>

				<div class="flex xend major-page" style="margin: 20px auto;" v-if="isShow">
					<el-pagination background layout="prev, pager, next" :page-size="size" @current-change="GetPageList" :current-page="page" :total="totleNum"></el-pagination>
				</div>
			</section>
		</div>
	</div>
</template>

<script>
import 'vue-area-linkage/dist/index.css';
import { pca, pcaa } from 'area-data';
import { mapState } from 'vuex';
export default {
	data() {
		return {
			options: [
				{
					value: '',
					label: '不分文理'
				},
				{
					value: '文科',
					label: '文科'
				},
				{
					value: '理科',
					label: '理科'
				}
			],
			value: '',
			pca: pca,
			pcaa: pcaa,
			isShow: false,
			selected2: [],
			isTab: 1,
			cityList: [],
			cityName: '',
			Score: '',
			page: 1,
			size: 10,
			totleNum: 0,
			list: [],
			TypeId1: 0,
			TypeId2: 0,
			TypeId3: 0
		};
	},
	// 加载
	created() {
		// this.cityList = this.$store.state.shop.currentProvince;
		this.$store.state.shop.currentProvince.map(ent => {
			if (ent.Code === this.$store.state.user.user.ProvinceCode.toString()) {
				this.cityList.push(ent);
			}
		});

		if (this.cityList.length > 0) {
			this.cityName = this.cityList[0].Code;
		}
		if (this.$route.query.key) {
			this.$api.reduceUserCount({ key: this.$route.query.key });
		} else {
			this.$router.back(-1);
		}

		console.log(this.cityList);
	},
	computed: {
		...mapState(['user', 'shop'])
	},
	watch: {
		'shop.currentProvince': {
			handler(newVal) {
				this.cityList = newVal;
			}
		}
	},
	methods: {
		// 个人中心
		goMyCenter() {
			this.$router.push('/myIndex');
		},

		selectlist() {
			if (this.Score === '') {
				this.$util.showError('请输入分数');
				return;
			}

			this.SmartMajor(1);
		},
		SmartMajor(page) {
			var that = this;
			that.isShow = false;

			var data = {
				page: page,
				size: 10,
				cityCode: that.cityName,
				candidatesType: that.value,
				score: that.Score === '' ? 0 : parseInt(that.Score),
				typeId: that.isTab
			};
			console.log(data);
			that.$api.HtppRequest(
				'SystemData/SmartMajor',
				'POST',
				data,
				function(res) {
					console.log('获取列表');
					console.log(res);
					if (res.flag && res.totle > 0) {
						var list = res.list;
						that.isShow = true;
						that.totleNum = res.totle;
						that.TypeId1 = res.TypeId1;
						that.TypeId2 = res.TypeId2;
						that.TypeId3 = res.TypeId3;
						if (page === 1) {
							that.list = [];
						}
						if (list.length > 0) {
							that.page = page;
							for (var i = 0; i < list.length; i++) {
								that.list.push(list[i]);
							}
						}

						console.log(that.list);
					}
				},
				function(err) {
					console.log(err);
				}
			);
		},

		tabClick(index) {
			this.isTab = index;
			this.SmartMajor(1);
		},
		// 获取其他页
		GetPageList: function(val) {
			var that = this;
			that.SmartMajor(val);
		}
	}
};
</script>

<style scoped>
.beiTxt span {
	color: #999;
}

.beiTxt {
	font-size: 14px;
	color: #333;
	margin-top: 10px;
}

.list-four p {
	font-size: 14px;
}

.list_head_flex .list-four:first-child {
	width: 45%;
}

.list_head_flex {
	overflow: hidden;
	display: flex;
	width: 72%;
}

.listTxt p:nth-child(n + 3) {
	text-align: center;
}

.listTxt p:last-child {
	text-align: right;
}

.listTxt p span {
	color: #333;
}

.listTxt p {
	width: 20%;
	float: left;
	font-size: 14px;
	color: #999;
}

.listTxt {
	margin-top: 30px;
	overflow: hidden;
}

.list-four hgroup i {
	width: 74px;
	height: 30px;
	border-radius: 4px;
	line-height: 30px;
	text-align: center;
	display: block;
	background-color: #fdc6c3;
	color: #ff3327;
	font-style: normal;
	margin-left: 2em;
	font-size: 14px;
}

.list-four hgroup p span {
	color: #333;
	margin-left: 6px;
	margin-right: 6px;
}

.list-four hgroup p {
	font-size: 14px;
	color: #999999;
}

.list-four h6 {
	font-size: 16px;
	color: #fff;
	border-radius: 50px;
	background-color: #333;
	min-width: 120px;
	text-align: center;
	padding: 0 15px;
	display: inline-block;
	font-weight: normal;
	height: 35px;
	line-height: 35px;
}

.list_head {
	overflow: hidden;
	display: flex;
}

.yuanList li {
	padding: 30px;
	background-color: #fff;
	border: solid 1px #e6e6e6;
	margin-top: 20px;
}

.yuanList {
	overflow: hidden;
}

.tabTop > p.on {
	background-color: #333;
	color: #fff;
}

.tabTop > p {
	cursor: pointer;
	font-size: 14px;
	text-align: center;
	width: 33.33%;
	border-top-left-radius: 4px;
	border-top-right-radius: 4px;
	height: 40px;
	line-height: 40px;
	color: #333;
	border: solid 1px #333;
	box-sizing: border-box;
}

.tabTop {
	margin: 30px 0 20px 0;
}

/* tabTop */

.yuan_head_hg p {
	font-size: 14px;
	color: #666666;
	margin-top: 10px;
}

.yuan_head_hg h6 {
	font-size: 14px;
	color: #f59a23;
	line-height: 22px;
	margin-bottom: 10px;
}

.yuan_head_hg hgroup {
	width: calc(100% - 30px);
}

.yuan_head_hg img {
	display: block;
	width: 22px;
	height: 22px;
}

.yuan_head_hg {
	padding: 15px 30px;
	display: flex;
}

/* yuan_head_hg */

* >>> .area-select .area-selected-trigger {
	color: #b7b7b7;
	line-height: 24px;
}
.yuan_tab {
	width: 65%;
}
* >>> .cascader-menu-list .cascader-menu-option.selected {
	color: #333 !important;
}

* >>> .area-select.large {
	width: 100%;
	height: 40px;
	box-sizing: border-box;
}

.way-test,
.yuanXz {
	width: 146px;
	height: 40px;
	margin-left: 20px;
}

.major-share-con {
	width: 75%;
	height: auto;
	overflow: ;
	display: flex;
	flex-wrap: wrap;
}
.share-li {
	width: 50%;
	display: flex;
	align-items: center;
	/* justify-content: center; */
	margin: 10px 0;
}

.share-li p {
	font-size: 14px;
	color: #333;
	width: 100px;
	text-align: right;
	margin-right: 20px;
}
.share-li input {
	width: 270px;
	height: 40px;
	line-height: 40px;
	padding: 0 10px;
	display: block;
	border-radius: 5px;
	background-color: #fff;
	color: #333;
	font-size: 14px;
}
.share-li input::-webkit-input-placeholder {
	color: #999;
}
.share-li input:-moz-placeholder {
	color: #999;
}
.share-li input:-ms-input-placeholder {
	color: #999;
}

.sjWidth {
	width: 270px;
}
.major-btn01 {
	width: 25%;
	display: flex;
	align-items: flex-end;
	margin-left: 20px;
}
.major-btn01 button {
	margin: 0px auto;
	width: 90px;
	font-size: 14px;
	margin-left: 0 !important;
	float: right;
}
.yuan_tab label {
	font-size: 14px;
	color: #333;
}

.yuan_head {
	padding: 0 36px;
	border-bottom: solid 2px #333;
	display: flex;
	padding-bottom: 36px;
}

.yuan_top {
	background-color: #eaeaea;
	padding: 36px 0;
	margin: 36px 0;
}

/* yuan_top */

.gaokao {
	width: 100%;
	height: auto;
	overflow: hidden;
}
.gaokao-nav {
	width: 100%;
	display: flex;
	align-items: center;
	padding: 20px 0;
}
.gaokao-nav span {
	font-size: 15px;
	color: #333;
}
.gaokao-nav span:last-child {
	color: #333;
}
/* gaokao-content */
.gaokao-content {
	padding: 0 20px;
	width: 100%;
	height: auto;
	overflow: hidden;
	background-color: #fff;
	margin-bottom: 25px;
}
.gaokao-con {
	padding: 50px 20px;
	height: auto;
	overflow: hidden;
}
.gaokao-con p {
	font-size: 14px;
	color: #333;
	text-indent: 2em;
	line-height: 28px;
}
/* gaokao-notice */
.gaokao-notice {
	width: 100%;
	padding: 0 40px 40px 40px;
	height: auto;
	overflow: hidden;
	background-color: #eee;
}
.gk-notice-tit {
	font-size: 17px;
	color: #333;
	padding: 40px 0;
}
.gk-notice-li {
	width: 100%;
	height: auto;
	overflow: hidden;
}
.gk-notice-li li {
	font-size: 15px;
	color: #333;
	padding-bottom: 15px;
}
.gk-notice-li li:last-child {
	padding-bottom: 0px;
}
.gaokao-btn {
	width: 200px;
	height: 40px;
	background-color: #333;
	border-radius: 6px;
	font-size: 16px;
	color: #fff;
	line-height: 40px;
	margin: 50px auto;
	display: block;
}
</style>
